/**
 * @desc 更新
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.LogisticsChannelPriceUpdateRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsChannelPrice/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
